module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "download"
  }, [_c('img', {
    staticClass: "bg",
    attrs: {
      "src": "static/img/bg.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": "static/img/logo2.png"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "logotxt",
    attrs: {
      "src": "static/img/logotxt.png"
    }
  }), _vm._v(" "), _c('p', [_vm._v("注册成功")]), _vm._v(" "), _c('span', [_vm._v("如何开启赚钱第一步")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.trackEvent($event)
      }
    }
  }, [_vm._v("点击下载淘金云客服app")])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-b29841b2", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b29841b2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/download.vue
// module id = 260
// module chunks = 1